import { useContext } from "react";
import { FormContextMA } from "../form-context";
import { DataField, Divider, H2, Section, TealSubSection } from "./common-components";
import {
  biologicalSexOptions,
  characteristicsOptions,
  genderOptions,
  medicationAdministrationOptions,
  raceOptions,
} from "../../patient/create/options";
import {
  calculateAgeYear,
  formatHealth,
  formatToYYYY_MMM_DD,
} from "../../../helpers/functions";
import { GetDropDownValue, GetMultiDropDownValue } from "./data";
import { AllergicRhinitisDocTypes } from "../../patient/clinical-services/service-steps/documentation/data";
import { GetAlertConfirmation } from "../../../helpers/constant";

export const PatientInformation = ({formType, patient, preAssessment, showAgeAlert = true}) => {
  // const { formType, patient, preAssessment } = useContext(FormContextMA);
  
  const isInterventionForm = (() => {
    if (!formType) return false;
    const lowerFormType = formType.toLowerCase();
    return lowerFormType.includes("intervention") || lowerFormType.includes("prescribing");
  })();
  
  return (
    <>
      {isInterventionForm ? (
        <div className="px-0">
          <div className="px-4 border-0 p-2">
            <H2>Patient Information</H2>
            <div className="flex-1 pr-2 py-0 space-y-1">
              <div className="grid grid-cols-1">
                <DataField
                  label="Patient Name"
                    value={(
                      (patient.firstName || "") +
                      (patient.middleName ? ` ${patient.middleName}` : "") +
                      (patient.lastName ? ` ${patient.lastName}` : "")
                    ).trim()}
                />  
              </div>
                <div className="mt-2">
                  <DataField
                    label="Health Card Number"
                    value={
                      patient?.provincialInsurance?.cardNumber
                        ? `${formatHealth(
                            patient.provincialInsurance.cardNumber
                          )}-${patient.provincialInsurance.versionCode}`
                        : "XXX-XXX-XXX-EF"
                    }
                  />
                </div>
              <div className="grid grid-cols-2 gap-8">
                <DataField
                  label="Date Of Birth"
                  value={
                    patient.dateOfBirth
                      ? formatToYYYY_MMM_DD(patient.dateOfBirth)
                      : ""
                  }
                />
                <DataField
                  label="Age"
                  value={
                    patient.dateOfBirth
                      ? calculateAgeYear(patient.dateOfBirth)
                      : ""
                  }
                />
              </div>
            </div>
          </div>
        </div>
      ) : [
        AllergicRhinitisDocTypes.PhysicianReferralForm,
        AllergicRhinitisDocTypes.PrescribingRecord,
        AllergicRhinitisDocTypes.PrescribingRecordWithReferral,
        AllergicRhinitisDocTypes.PhysicianReferralForm,
      ].includes(formType) ? (
        <>
          <Section formType={formType} className=" bg-gray-10 border border-gray-200 rounded-[4px]">
            <H2>Patient Information</H2>
            <div className="grid grid-cols-1">
              <DataField
                label="Patient Name"
                value={(
                  (patient.firstName || "") +
                  (patient.middleName ? ` ${patient.middleName}` : "") +
                  (patient.lastName ? ` ${patient.lastName}` : "")
                ).trim()}
              />
            </div>
            <div className="mt-2">
              <DataField
                label="Health Card Number"
                value={
                  patient?.provincialInsurance?.cardNumber
                    ? `${formatHealth(
                        patient.provincialInsurance.cardNumber
                      )}-${patient.provincialInsurance.versionCode}`
                    : "XXX-XXX-XXX-EF"
                }
              />
            </div>
            <div className="grid grid-cols-4">
              <DataField
                label="Date Of Birth"
                value={
                  patient.dateOfBirth
                    ? formatToYYYY_MMM_DD(patient.dateOfBirth)
                    : ""
                }
              />
              <DataField
                label="Age"
                value={
                  patient.dateOfBirth
                    ? calculateAgeYear(patient.dateOfBirth)
                    : ""
                }
              />
              <DataField
                label="Gender"
                value={GetDropDownValue(genderOptions, patient.gender)}
              />
            </div>
          </Section>
        </>
      ) : (
        <>
          <Section formType={formType} className="p-4 bg-gray-10 border border-gray-200 rounded-[4px]">
            <H2>Patient Information</H2>
            <div className="grid grid-cols-2">
              <DataField
                label="Patient Name"
                value={(
                  (patient.firstName || "") +
                  (patient.middleName ? ` ${patient.middleName}` : "") +
                  (patient.lastName ? ` ${patient.lastName}` : "")
                ).trim()}
              />
            </div>
            <Divider />
            <div className="grid grid-cols-3">
              <DataField
                label="Date Of Birth"
                value={
                  patient.dateOfBirth
                    ? formatToYYYY_MMM_DD(patient.dateOfBirth)
                    : ""
                }
              />
              <DataField
                label="Age"
                value={
                  patient.dateOfBirth
                    ? calculateAgeYear(patient.dateOfBirth)
                    : ""
                }
              />
              <DataField
                label="Race"
                value={GetDropDownValue(raceOptions, patient.race)}
              />
            </div>
            <div className="grid grid-cols-3">
              <DataField
                label="Gender"
                value={GetDropDownValue(genderOptions, patient.gender)}
              />
              <DataField
                label="Biological Sex"
                value={GetDropDownValue(
                  biologicalSexOptions,
                  patient.biologicalSex
                )}
              />
            </div>
            {showAgeAlert && preAssessment.ageAlertConfirmationType !== null && preAssessment?.ageAlertConfirmationType !== 0 && (
              <TealSubSection className="space-y-[0.0416667in]">
                {/* TODO: data for values? */}
                <DataField label="Referral Reason" value={"Age Alert"} />
                <DataField
                  label="Referral Type"
                  value={GetAlertConfirmation(
                    preAssessment?.ageAlertConfirmationType
                  )}
                />
                {(preAssessment?.ageAlertConfirmationType === 1 ||
                  preAssessment?.ageAlertConfirmationType === 2) && (
                  <DataField
                    label="Explanation"
                    value={preAssessment?.ageAlertExplaination}
                  />
                )}
                <DataField
                  label={`Pharmacist Clinical Decision to ${
                    preAssessment?.ageAlertConfirmationType === 4
                      ? "End Service"
                      : "Continue with Service"
                  }`}
                  value={""}
                />
              </TealSubSection>
            )}
          </Section>

          <Section formType={formType}>
            <H2>Patient Details</H2>
            <div className="grid grid-cols-2">
              <DataField
                label="Medication Administration"
                value={GetDropDownValue(
                  medicationAdministrationOptions,
                  patient.medicationAdministration
                )}
              />
              <DataField
                label="Characteristics"
                value={GetMultiDropDownValue(
                  characteristicsOptions,
                  patient.characteristics
                )}
              />
            </div>
          </Section>
        </>
      )}
    </>
  );
};
